import AdminRoute from "./routes/AdminRoute";
import OperRoute from "./routes/OperRoute";
import UserRoute from "./routes/UserRoute";
import TecRoute from "./routes/TecRoute";
import { BrowserRouter, Routes, Route } from "react-router-dom";

// Layouts
import LayoutAdmin from "./layouts/LayoutAdmin";
import LayoutUsers from "./layouts/LayoutUsers";

// Auth
import Login from "./pages/auth/Login";

// Admin Pages
import Home from "./pages/Home";
import Productos from "./pages/productos";

// User Pages
import UserHome from "./pages/UserHome";
import AddTicket from "./pages/AddTicket";
import EditTicket from "./pages/EditTicket";
import PdfTicket from "./pages/PdfTicket";
import Presupuesto from "./pages/presupuesto";
import Aprobados from "./pages/Aprobados";
import Cancelados from "./pages/Cancelados";
import Ticket from "./pages/Ticket";
import Instalacion from "./pages/instalacion";
import AddInstal from "./pages/addInstal";
import ViewInstall from "./pages/viewInstall";
import Parte from "./pages/parte";

// Error
import Error404 from "./pages/Error404";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        {/* Rutas protegidas para admin */}
        <Route path="/" element={<AdminRoute />}>
          <Route element={<LayoutAdmin />}>
            <Route index element={<Home />} />
            <Route path="productos" element={<Productos />} />
            <Route path="instalacion" element={<Instalacion />} />
            <Route path="presupuesto" element={<Presupuesto />} />
            <Route path="aprobados" element={<Aprobados />} />
            <Route path="cancelados" element={<Cancelados />} />
            <Route path="addTicket" element={<AddTicket />} />
            <Route path="editTicket/:id" element={<EditTicket />} />
            <Route path="pdfTicket/:id" element={<PdfTicket />} />
            <Route path="ticket" element={<Ticket />} />
            <Route path="addInstal" element={<AddInstal />} />
            <Route path="viewInstall/:id" element={<ViewInstall />} />
            <Route path="parte" element={<Parte />} />
            <Route path="UserHome" element={<UserHome />} />
          </Route>
        </Route>

        {/* Rutas para usuarios normales */}
        <Route path="/users/" element={<UserRoute />}>
          <Route element={<LayoutUsers />}>
            <Route index element={<UserHome />} />
            <Route path="productos" element={<Productos />} />
            <Route path="instalacion" element={<Instalacion />} />
            <Route path="presupuesto" element={<Presupuesto />} />
            <Route path="aprobados" element={<Aprobados />} />
            <Route path="cancelados" element={<Cancelados />} />
            <Route path="addTicket" element={<AddTicket />} />
            <Route path="editTicket/:id" element={<EditTicket />} />
            <Route path="pdfTicket/:id" element={<PdfTicket />} />
            <Route path="ticket" element={<Ticket />} />
            <Route path="addInstal" element={<AddInstal />} />
            <Route path="viewInstall/:id" element={<ViewInstall />} />
            <Route path="parte" element={<Parte />} />
            <Route path="UserHome" element={<UserHome />} />
          </Route>
        </Route>

        {/* Rutas para operadores */}
        <Route path="/oper/" element={<OperRoute />}>
          <Route element={<LayoutUsers />}>
            <Route index element={<UserHome />} />
            <Route path="ticket" element={<Ticket />} />
            <Route path="addTicket" element={<AddTicket />} />
            <Route path="editTicket/:id" element={<EditTicket />} />
            <Route path="pdfTicket/:id" element={<PdfTicket />} />
            <Route path="UserHome" element={<UserHome />} />
          </Route>
        </Route>

        {/* Rutas para tecnicos */}
        <Route path="/tec/" element={<TecRoute />}>
          <Route element={<LayoutUsers />}>
            <Route index element={<UserHome />} />
            <Route path="ticket" element={<Ticket />} />
            <Route path="pdfTicket/:id" element={<PdfTicket />} />
            <Route path="addInstal" element={<AddInstal />} />
            <Route path="instalacion" element={<Instalacion />} />
            <Route path="viewInstall/:id" element={<ViewInstall />} />
            <Route path="parte" element={<Parte />} />
            <Route path="UserHome" element={<UserHome />} />
          </Route>
        </Route>

        <Route path="*" element={<Error404 />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
